import { Select } from "antd";
import React from "react";
import { Region, region, regions, setRegion } from "../apiMiddleware/region";
import { Lan } from "../locale";
import { FormattedMessage } from "react-intl";

const { Option } = Select;

export interface SwitchRegionProps {
    onChange?: (region: string) => void;
}

export default class SwitchRegion extends React.Component<SwitchRegionProps> {
    public render(): React.ReactNode {
        return (
            <>
                <FormattedMessage id={"global.region"} />
                <span style={{ paddingRight: 12 }}>:</span>
                <Select defaultValue={region} onChange={this.onChange}>
                    {regions[this.getLang()].map(({ name, region, emoji }) => (
                        <Option key={region} value={region}>{emoji} {name}</Option>
                    ))}
                </Select>
            </>
        );
    }

    private getLang(): Lan {
        return window.location.pathname.split("/")[1] as Lan;
    }

    public onChange = (_region: Region): void => {
        setRegion(_region);
        this.props.onChange?.(_region);
    }
}



// WEBPACK FOOTER //
// ./src/components/SwitchRegion.tsx